export class Download {
  downloadId?: string;
  status: DownloadStatus;
  errorMessage?: string;
  url?: string;
}

export enum DownloadStatus {
  pending = 'pending',
  error = 'error',
  success = 'success'
}



// WEBPACK FOOTER //
// ./src/app/models/download.model.ts